<script>
import { TIME_RANGES } from './severity';

export default {
    name: 'QueryBar',
    props: {
        filters: { type: Object, required: true },
        loading: { type: Boolean, default: false },
    },
    emits: ['run', 'reload'],
    data() {
        return { timeRanges: TIME_RANGES };
    },
};
</script>

<template>
    <div class="logs-query-bar">
        <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
            <input
                v-model="filters.search"
                type="text"
                class="form-control"
                placeholder="Search all messages…"
                @keyup.enter="$emit('run')"
            />
            <span class="input-group-btn" style="width: 160px">
                <select v-model="filters.rangeKey" class="form-control" @change="$emit('run')">
                    <option v-for="range in timeRanges" :key="range.key" :value="range.key">
                        {{ range.label }}
                    </option>
                </select>
            </span>
            <span class="input-group-btn">
                <button
                    type="button"
                    class="btn btn-default"
                    title="Reload"
                    :disabled="loading"
                    @click="$emit('reload')"
                >
                    <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
                </button>
            </span>
            <span class="input-group-btn">
                <button class="btn btn-primary" :disabled="loading" @click="$emit('run')">
                    <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-play'"></i>
                    Run query
                </button>
            </span>
        </div>
    </div>
</template>
